<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div
            class="md-layout md-layout-item md-size-65 md-small-size-90 mx-auto"
            style="margin-bottom:0px"
          >
            <!-- {{model}} -->
            <div
              class="md-layout md-alignment-center-top"
              style="margin-bottom:0px; padding:10px 0px"
            >
              <!-- <div class="md-layout-item md-size-25 md-medium-size-33 md-xsmall-size-90"> -->
              <div class="md-layout-item md-size-100 text-center">
                <img
                  :src="logotypeUrl"
                  @error="imgNotLoaded"
                  style="margin-bottom:40px;margin-top:10px;max-height:300px !important"
                />
              </div>
              <div class="md-layout-item" style="margin-left:10px">
                <h3 class="bold text-primary" style="margin:0px">{{model.description.name}}</h3>

                <div
                  v-if="model.description.description"
                  class="text-gray regular"
                  style="font-size:14px; margin:0px 10px 10px 0px"
                >{{model.description.description}}</div>

                <!-- <p v-if="model.description.description">{{model.description.description}}</p>-->
                <div
                  v-if="model.description.url"
                  class="text-gray regular"
                  style="font-size:14px; margin:0px 10px 10px -4px"
                >
                  <a :href="model.description.url" target="_blank" class="text-gray">
                    <md-icon style="margin-left:0px; padding-left:0px">public</md-icon>
                    {{model.description.url}}
                  </a>
                </div>
              </div>
            </div>

            <div
              v-if="model.attendees.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <h3 class="text-primary bold" style="margin-bottom:5px">{{$t(`Representatives`)}}</h3>
              <hr class="text-primary" />
              <attendee-item
                v-for="a in model.attendees"
                :key="a.id"
                :item="a"
                showDetailsLink="true"
              />
            </div>

            <div
              v-if="model.panels.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <h3
                class="text-primary bold"
                style="margin-bottom:5px"
              >{{$t(`Panels under patronage`)}}</h3>
              <hr class="text-primary" />

              <panel-item
                v-for="p in model.panels"
                :key="p.id"
                :item="p"
                :showDetailsLink="true"
                :showDate="true"
              />
            </div>

            <div
              v-if="model.invitations.length"
              style="margin:25px 0px"
              class="md-layout md-layout-item md-size-100"
            >
              <h3
                class="text-primary bold"
                style="margin-bottom:5px"
              >{{$t(`Partner's invitations`)}}</h3>
              <hr class="text-primary" />

              <div
                v-for="item in model.invitations"
                :key="item.id"
                style="margin:0px 0px;"
                class="md-layout-item md-size-100"
              >
                <div class="notification-item" @click="selectedInvitation = item">
                  <span class="text-gray regular" style="font-size:18px">{{item.description.title}}</span>
                </div>
              </div>
            </div>

            <div class="md-layout md-layout-item md-size-100">
              <div class="ml-auto">
                <md-button
                  v-if="model.roomId"
                  @click.prevent="showOnMap"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px 10px 0px 0px"
                >{{$t('Show on map')}}</md-button>
                <md-button
                  @click.prevent="$router.go(-1)"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px"
                >{{$t('Go back')}}</md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedRoomData }">
      <modal v-if="selectedRoomData" @close="selectedRoomData = null" id="building-modal">
        <template slot="header">
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedRoomData = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <building-details
            :id="selectedRoomData.buildingId"
            :floorId="selectedRoomData.floorId"
            :roomId="selectedRoomData.roomId"
            :readonly="true"
          />
        </template>
      </modal>
    </div>

    <div class="modal modal-bg" :class="{ show: selectedInvitation }">
      <modal v-if="selectedInvitation" @close="selectedInvitation = null" id="invitation-modal">
        <template slot="header">
          <h3 class="title" style="margin:0px">{{selectedInvitation.description.title}}</h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedInvitation = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="selectedInvitation.description.content" />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";
import PanelItem from "./components/Agenda/PanelListItem.vue";
import AttendeeItem from "./components/Attendees/AttendeesListItem.vue";
import PageHeader from "./layout/PageHeader";
import { Modal } from "@/components";
import BuildingDetails from "@/pages/authenticated/BuildingDetailsPage.vue";

export default {
  components: { AttendeeItem, PanelItem, PageHeader, BuildingDetails, Modal },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    }),
    logotypeUrl() {
      return axios.getFileUrl(this.model.description.logoId);
    }
  },
  props: ["id"],
  data() {
    return {
      loaded: false,
      selectedRoomData: null,
      selectedInvitation: null,
      model: { description: {}, attendees: [], panels: [], invitations: [] },
      image: require("@/assets/img/conference/landing-bg.jpg") // header img
    };
  },
  methods: {
    async showOnMap() {
      if (!this.model.roomId) return;

      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        let result = (
          await axios.get("public/conferences/conference/roomData", {
            params: {
              id: this.model.roomId
            }
          })
        ).data;

        this.selectedRoomData = result;
      } finally {
        loader.hide();
      }
    },
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.model = (
          await axios.get("public/conferences/conference/partners/details", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              id: this.id
            }
          })
        ).data;
      } finally {
        loader.hide();
        this.loaded = true;
      }
    },
    fileUrl(id) {
      return axios.getFileUrl(id);
    },
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.hidden = true;
        //event.target.src = require("@/assets/img/blank_avatar.png");
      }
      this.imgLoaded = true;
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    async language() {
      this.loaded = false;
      this.model = { description: {}, attendees: [], panels: [] };
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}

.notification-item {
  cursor: pointer;
  margin: 0px 0px;
  padding: 7px 0px;
  &:hover {
    box-shadow: 0px 0px 30px #0000000d;
    border-radius: 15px;
    opacity: 1;
  }
}
</style>
